import { render, staticRenderFns } from "./EmailSuccess-Mobile.vue?vue&type=template&id=15059bb1&scoped=true"
import script from "./EmailSuccess-Mobile.vue?vue&type=script&lang=js"
export * from "./EmailSuccess-Mobile.vue?vue&type=script&lang=js"
import style0 from "./EmailSuccess-Mobile.vue?vue&type=style&index=0&id=15059bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15059bb1",
  null
  
)

export default component.exports